import React from "react";

const aman_morghade = () => {
  return (
    <div>
      <h1>Aman Morghade</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The eligibility criteria was : 7+ CGPA for CSE Branch and 8+ CGPA for
        other Circuital Branches (EnTC, Electrical and Instrumentation), with no
        backlogs.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The company pre-placement talk was held on 24th July at 9AM followed by
        Online Aptitude Test. The results came around 3PM and the interviews
        were scheduled the same for some people the following day.
        <br />
        Interviews concluded at around 4:30PM on 25th July and the results were
        announced the same day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Duration of the aptitude round was: 65mins.
        <br />
        There were 3 sections and the time was not carried forward from section
        to section.
        <br />
        1. Coding(25 mins): It was a medium level problem on arrays, based on
        dynamic programming and backtracking.
        <br />
        2. Technical MCQs (20 mins): Questions based on DSA (Hashing methods),
        DBMS and CN (topology).
        <br />
        3. Mathematical/Quantitative Aptitude (20mins): Questions were based on
        logical reasoning, equations, surface area etc.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        153 students were eligible for the aptitude test post which 16 students
        were shortlisted for the interviews.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist for the interviews was released on the same day after the
        aptitude test and Technical round 1 also began that day. Initially, I
        was told that my interview was scheduled the same day but due to time
        constraints, it got shifted to the following day. Having a day's time in
        hand, I revisited OS concepts and focused on DBMS Queries. I also
        practiced some brainteaser puzzles which are common in the interviews.
        Finally I reviewed my resume during the night and prepared a list of
        questions alongside a strategy to answer those questions.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        Structure of the complete process:
        <br />
        1. Technical Round - 1<br />
        2. Technical Round - 2<br />
        3. HR/Professional Fitness Round
      </p>

      <p>16 Students were selected for the interviews.</p>

      <p>
        1. Technical Round - 1:
        <br />
        The interview panel had 2 members for this round. It was around (35-40)
        minutes and was primarily focused on the projects mentioned in my
        resume. The interviewers went through every line mentioned under project
        headings and I was questioned based on choice of technology stack, key
        concepts used, challenges faced in that project and optimizations that
        can improve it. I had put up 2 selected projects, out of which one was
        Java + SpringBoot Microservice and other one was Git-Like Version
        Control System in C. For the first one, I was asked that why did I
        choose this project and Java as the TechStack. Then I was asked about
        Threads in Java, synchronization methods/locks and Garbage Collection
        Mechanisms. Then the discussion shifted to Spring Concepts (What is
        Inversion of Control?, Explain JDBC and Persistence API, What are
        Beans?. Then I was asked about some common Annotations for eg.
        @RestController, @Component and Repository). Finally they asked me about
        dependency injection and what is Autowiring?
        <br />
        For the second project, I was questioned about the internal working of
        Git, How the staging area works? How are commit trees formed and saved
        as files? How are new commits built on top of existing snapshots and
        What are Conflicts during merge?
        <br />
        Then I was given a scenario with a git commit history with 6 branches
        and I was asked to merge 3 branches to a target branch with one of them
        being in linear fashion (i.e on top of the previous commits), one was to
        rollback to a particular commit and in one branch I had to remove a
        specific commit and apply it to a spare branch. This was to check my
        proficiency in git commands and the concepts used here were (git reset,
        rebase, cherry-pick and merge).
        <br />
        In the end, I was asked about my educational background and the
        interview concluded on a positive note.
      </p>

      <p>
        2. Technical Round - 2:
        <br />
        The interview panel had 2 members for this round. It was around (50)
        minutes and was a mix of DSA, System Design and Core Subjects. The
        interviewers began by presenting a DSA question (There is a huge volume
        of Data Stream which are logs being stored. The logs are key value
        pairs. I was asked to find the median of the stream, grouped according
        to the keys). I gave the brute force solution which was to process the
        log history, sort the entire list for a particular key value, which I
        then optimized to a constant time complexity by using the Two-Heap
        Method. I was also asked to design a LRU cache as a follow-up question.
        <br />
        The panel then gave me a scenario of a system having central file system
        hosted on a remote server consisting of a single PC. The data from all
        sources is transferred overnight to the server. I was asked to give the
        possible challenges that can be faced and what all things will I ensure
        so that the system remains intact? The question had multiple answers and
        the goal here was to check whether I'm able to brainstorm the ideas on
        time or not?
        <br />
        Then, I was asked to write SQL queries based on joining multiple tables,
        consisting of duplicates and was questioned about OS Concepts
        (Semaphores, Mutexes, Deadlock Resolution Strategies, Time Complexity of
        Banker's Algorithm, When is OS loaded in the memory and what is the
        purpose of BIOS?).
        <br />
        The interview concluded with an HR based question (It was about conflict
        resolution over the choice of an elective subject presented to the class
        between the students and college officials, as the class
        representative.)
      </p>

      <p>
        3. Professional Fitness/HR Round:
        <br />
        This round was for around (10-15) min. The interviewer asked me about my
        background, career and coding journey. I was also questioned about if I
        were to start all again, where will I improve myself? The interview
        concluded with a discussion on time management and club activities that
        I’m a part of.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        Aptitude Round - DSA, DBMS, Computer Networks, Time and Work, Ratio,
        Permutation and Combination
        <br />
        Technical Round - 1: (Project Based Questions)
        <br />
        Technical Round - 2: DSA (Medium-Hard), DBMS (Joins + Indexes), OS, High
        Level System Design, Behavioural Questions (1-2)
        <br />
        HR/Pro-Fit Round: Behavioural Questions
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA:
      </p>

      <ol>
        <li>
          Striver’s SDE Sheet:{" "}
          <a href="https://takeuforward.org/interviews/strivers-sde-sheet-top-coding-interview-problems">
            Link
          </a>{" "}
        </li>
        <li>
          Aditya Verma’s DP Playlist:{" "}
          <a href="https://www.youtube.com/watch?v=nqowUJzG-iM&list=PL_z_8CaSLPWekqhdCPmFohncHwz8TY2Go&index=1">
            Link
          </a>{" "}
        </li>
        <li>
          Striver’s Graph Playlist:{" "}
          <a href="https://www.youtube.com/watch?v=M3_pLsDdeuU&list=PLgUwDviBIf0oE3gA41TKO2H5bHpPd7fzn&index=1">
            Link
          </a>{" "}
        </li>
        <li>
          CSES CP Problem Set: <a href="https://cses.fi/problemset/">Link</a>{" "}
        </li>
        <li>
          Core Subjects: Standard Reference Books +{" "}
          <a href="https://takeuforward.org/interviews/must-do-questions-for-dbms-cn-os-interviews-sde-core-sheet/">
            Must Do Questions
          </a>{" "}
        </li>
        <li>
          Top OS QnA:{" "}
          <a href="https://leetcode.com/discuss/post/5873921/Part-3%3A-Top-17-OS-interview-questions-with-answers/">
            Link
          </a>{" "}
        </li>
        <li>
          IndiaBix Aptitude:{" "}
          <a href="https://www.indiabix.com/aptitude/questions-and-answers/">
            Link
          </a>
        </li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        The most important thing is <em>consistency</em>. Regular practice helps
        you recognize the underlying patterns that appear across most coding
        problems. Once you start solving questions daily, you’ll notice that
        many of them share similar logic or techniques, and that’s where your
        confidence builds.
      </p>

      <p>
        It’s also crucial to prepare with focus. Start early, pick a few good
        problem sources, and stick to a routine. Don’t just read solutions!
        Understand <em>why</em> each step works. Over time, this consistency and
        focus make problem-solving feel natural, and that’s the real key to
        cracking coding interviews.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?
      </p>

      <p>
        In <strong>Technical Round 1</strong>, the discussion was heavily
        focused on my projects and internship experiences. I was asked several
        questions about the technologies I used, my key learnings, and even some
        technical details related to Android SDK compilation and Gradle
        configuration used during internship. Most of the questions in this
        round revolved around my projects, covering their implementation,
        challenges faced, and outcomes.
      </p>

      <p>
        In <strong>Technical Round 2</strong>, the focus slightly shifted
        towards my extracurricular activities, where I was asked about my
        hobbies. Finally, in the <strong>HR round</strong>, I was asked about my
        participation in clubs and how I managed my time between academics,
        projects, and extracurricular engagements.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Preparation isn’t really company specific and the fundamentals remain
        the same across all organizations. What truly matters is role alignment
        and making sure your skills and experiences match the requirements of
        the role you’re applying for. Once you’re clear about how your skills
        align with the role and express that confidently, it really stands out
        to the interviewer.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Stay consistent and trust your preparation. Focus on building strong
        fundamentals instead of rushing through topics. Regular practice is
        important! Whether it’s coding, revising core concepts, or working on
        projects, it really makes a difference. Document your work well and be
        confident while explaining it during interviews.
      </p>

      <p>
        Most importantly, don’t be disheartened by rejections and treat them as
        valuable learning experiences that help you perform better in future
        opportunities. Everyone’s journey is different, so focus on improving a
        little every day and keep moving forward.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:amanbm23.comp@coeptech.ac.in">amanbm23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/amanmorghade/">Aman Morghade</a>
      </p>
    </div>
  );
};

export default aman_morghade;
